import { useMemo } from 'react';
import { getKeywordMap } from '../../../prompt/preview/components/stats/helpers/StatsHelper';
import { KeywordResponse } from '../../../../shared/models/monitor/KeywordResponse';
import { MonitorPrompt } from '../../../../shared/models/monitor/MonitorPrompt';

export const useKeywordMapper = (
  commonKeywords: KeywordResponse[],
  monitorPrompts: MonitorPrompt[] | null
) =>
  useMemo(() => {
    if (!commonKeywords || !monitorPrompts) {
      return new Map<string, string>();
    }

    return getKeywordMap(commonKeywords);
  }, [commonKeywords, monitorPrompts]);
